import * as React from "react";

const BBVABancomerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={32} height={20} rx={6} fill="#004481" />
    <g transform="translate(-11.5, -7.38) scale(0.55)">
      <path fill="#fff" d="M63.88,26.11l-4.63,8.82c-.1.19-.39.19-.49,0l-4.63-8.82c-.04-.09-.13-.14-.23-.14h-2.25c-.15,0-.25.16-.18.3l7.3,13.67c.1.19.37.19.48,0l7.3-13.67c.07-.13-.03-.3-.18-.3h-2.25c-.11,0-.2.05-.24.14h0Z"/>
      <path fill="#fff" d="M66.51,37.89l4.63-8.82c.1-.19.39-.19.49,0l4.63,8.82c.04.09.13.14.23.14h2.25c.15,0,.25-.16.18-.3l-7.3-13.67c-.1-.19-.37-.19-.48,0l-7.3,13.67c-.07.13.03.3.18.3h2.25c.1,0,.2-.06.24-.14h0Z"/>
      <path fill="#fff" d="M34.83,32.47c.97-.49,1.57-1.54,1.57-2.82,0-2.2-1.72-3.69-4.13-3.69h-6.94c-.15,0-.27.12-.27.27v13.57c0,.15.12.27.27.27h6.65c3.32,0,5.07-1.43,5.07-4.23s-2.22-3.37-2.22-3.37h0ZM27.66,28.01h4.12c1.52,0,2.29.65,2.29,1.85s-.77,1.85-2.29,1.85h-4.12c-.14,0-.27-.12-.27-.27v-3.16c0-.15.12-.27.27-.27h0ZM31.84,38.02h-4.18c-.15,0-.27-.12-.27-.27v-3.75c0-.14.12-.27.27-.27h4.18c1.99,0,2.88.57,2.88,2.14,0,1.59-.87,2.15-2.88,2.15h0Z"/>
      <path fill="#fff" d="M49.08,32.47c.97-.49,1.57-1.54,1.57-2.82,0-2.2-1.72-3.69-4.13-3.69h-6.95c-.15,0-.27.12-.27.27v13.57c0,.15.12.27.27.27h6.65c3.32,0,5.07-1.43,5.07-4.23,0-2.73-2.21-3.37-2.21-3.37h0ZM41.91,28.01h4.12c1.52,0,2.29.65,2.29,1.85s-.77,1.85-2.29,1.85h-4.12c-.15,0-.27-.12-.27-.27v-3.16c0-.15.12-.27.27-.27h0ZM46.08,38.02h-4.18c-.14,0-.27-.12-.27-.27v-3.75c0-.14.12-.27.27-.27h4.18c1.99,0,2.88.57,2.88,2.14s-.87,2.15-2.88,2.15h0Z"/>
    </g>
  </svg>
);

export default BBVABancomerIcon;
